module.exports = __webpack_public_path__ + "static/media/logo-mobioh-branco.98831851.webp";